// extracted by mini-css-extract-plugin
module.exports = {"saveRow":"_15012__add-module__save-row","addRow":"_0b78e__add-module__add-row"};